module.exports = __webpack_public_path__ + "static/media/group.f21a60ca.svg";